'use strict';

define('vb/private/vx/extensionAdapterFactory',['vb/private/utils',
], (Utils) => {
  const extensionAdapterCache = {};

  /**
   * Factory class for retrieving the class name for the extension adapter
   */
  class ExtensionAdapterFactory {
    /**
     * @param {String}registryUrlParam  The url for the Extension Registry Manager
     * returns the Adapter resource used for working with the Extension Registry
     */
    static get(registryUrlParam) {
      // Depending on the format of the URL, use different adapter class
      let adapterName = 'baseExtensionAdapter';
      const initConfig = window.vbInitConfig || {};
      let registryUrl = registryUrlParam || initConfig.REGISTRY_URL;

      if (Utils.isMobile()) {
        adapterName = 'nativeMobileExtensionAdapter';
      } else if (typeof registryUrl === 'string') {
        registryUrl = registryUrl.trim();
        if (registryUrl.startsWith('http')) {
          // TODO implement a PWA adaptor by checking PwaUtils.isPwaConfig(window.vbInitConfig)
          adapterName = 'remoteExtensionAdapter';
        } else if (registryUrl) {
          adapterName = 'localExtensionAdapter';
        }
      }

      // Find it in cache first, so that we can reuse it
      let adapter = extensionAdapterCache[registryUrl];
      if (adapter) {
        return Promise.resolve(adapter);
      }

      // Create one if not found in cache
      return Utils.getResource(`vb/private/vx/${adapterName}`)
        .then((Adapter) => {
          adapter = new Adapter(registryUrl);
          // cache the one created
          extensionAdapterCache[registryUrl] = adapter;
          return adapter;
        });
    }
  }

  return ExtensionAdapterFactory;
});

